
import { ApiMethods, AxiosClient } from "@/api/ApiClient";
import { ApiEndpoints } from "@/api/ApiEndpoints";
import { Values } from "@/constants/Values";
import { SearchParams, UserPageProps } from "@/types/Users";
import { FilterVenuesType,GetSlotsByDateType,InitPaymentForPendingBookingtype,PriceAferCouponAppliedType, rescheduleBookingType} from "@/types/interfaceType";

export interface LoginPayload {
  phoneNumber?: number,
  emailId?: string,
  loginType?: string,
  googleToken?: string
}

export type UploadUsersPayload = {
  file: string;
  metadata: {
    attributeMapping: {
      [key: string]: string
    }
  }
}

export interface WriteReviewInterface {
  venueId: string,
  bookingId: string,
  rating: number
  comment?: string
}

const ApiBuilder = {
  //user


  login: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.login,
      data: data
      // data,
    });
  },

  logout: async () => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.login,
      // data,
    });
  },

  verifyOtp: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.verifyOtp,
      data: data
      // data,
    });
  },


  //Venues

  venuesList: async (payload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.venuesList,
      data: payload,
      showCustomError:false,
      showHeaderToast:false,
      // data,
    });
  },

  getVendorRegisterVenues:  async (payload) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.getVendorRegisterVenues,
      data: payload,
      // data,
    });

  },
  venueDetailsList: async (params: any,data?:{lat?:Number,lng?:Number,city?:String}) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVenueDetails,
      pathParam: params,
      data
    });
  },

  getProfile: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getProfile,
    });
  },

  getProfileV2: async (token:string) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getProfile,
      customToken:token
    });
  },


  updateUserProfile: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.PUT,
      url: ApiEndpoints.updateUserProfile,
      data
    });
  },

  getStaticPaymentFeeDetails: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getStaticPlatformFeeConfig,
    });
  },

  createBooking: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.createBooking,
      data,
      showCustomError:true,
      showSuccessMessage:false
    });
  },

  DBLcreateBooking: async (data: any,pathParam:string) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.DBLcreateBooking,
      data,
      pathParam,
      showCustomError:true,
      showSuccessMessage:false
    });
  },
  initPaymentForPendingBooking: async (data: InitPaymentForPendingBookingtype) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.initPaymentForPendingBooking,
      data,
      showCustomError:false,
      showSuccessMessage:false
    });
  },
  cancelBooking: async (params: any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.cancelBooking,
      pathParam: params,
      showCustomError:true,
      showSuccessMessage:false
    });
  },
  cancelPendingBooking: async (params: any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.cancelPendingBooking,
      pathParam: params,
      showCustomError:false,
      showSuccessMessage:false
    });
  },
  getMyBookings: async (queryParams:{page:number,limit:number,status:string}) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getMyBookings,
      data:queryParams?queryParams:{page:1,limit:10},
      showCustomError:false,
      showSuccessMessage:false
    });
  },

  getmyBookingsWithPagination: async (queryParams:{page:number,limit:number,status?:any}) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getmyBookingsWithPagination,
      data:queryParams?queryParams:{page:1,limit:Values.myBookingLimit},
      showSuccessMessage:false
    });
  },

  wishlist:async (data:{venueId:string}) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.getMyBookings,
      data:data
    });
  },
  getUserPendingBookings: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getUserPendingBookings,
      showCustomError:false,
      showSuccessMessage:false
    });
  },

  verifyPayment: async (data: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.verifyPayment,
      data,
      showCustomError:false,
      showSuccessMessage:false
    });
  },

  getCategories: async () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getCategories,
    });
  },

  getNearbyTurfs: async (payload: any) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.getNearbyVenues,
      data: payload
    });
  },

  writeReview: async (payload: WriteReviewInterface) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.writeReview,
      data: payload
    });
  },
  getAllReviews: async (pathParam:string, queryParams: any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getAllReviews,
      data: queryParams,
      pathParam
    });
  },
  filterVenues:async (payload: FilterVenuesType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.filterVenues,
      data: payload
    });
  },

  getSlotsByDate:async (payload: GetSlotsByDateType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.getSlotsByDate,
      data: payload,
      showSuccessMessage:false,
    });
  },

  getWebsiteBySubdomain:async (pathParam:string) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getWebsiteBySubdomain,
      pathParam,
      showCustomError:false,
      showFooterToast:false,
      showSuccessMessage:false,
      showHeaderToast:false
    });
  },
  validateDirectBookingLink:async (pathParam:string) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.validateDirectBookingLink,
      pathParam,
      useDBLToken:true
    });
  },

  getDirectBookingLinkVenueSlotsByDate:async (pathParam:string,payload:GetSlotsByDateType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.getDirectBookingLinkVenueSlotsByDate,
      pathParam,
      data: payload,
      showSuccessMessage:false,
      useDBLToken:true
    });
  },

  getPlatformOffers:async (pathParam:String,  token?:string) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getPlatformOffers,
      customToken:token,
      pathParam
    });
  },

    getGlobalPlatformOffers:async  () => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getGlobalPlatformOffers,
      
    });
  },
  getDBLPlatformOffers:async (pathParam:String) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getDBLPlatformOffers,
      pathParam
    });
  },
  previewBookingPriceAferCouponApplied:async(payload:PriceAferCouponAppliedType)=>{
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.previewBookingPriceAferCouponApplied,
      data:payload
    });
  },
  previewDBLBookingPriceAferCouponApplied:async(payload:PriceAferCouponAppliedType,pathParam:string)=>{
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.previewDBLBookingPriceAferCouponApplied,
      data:payload,
      pathParam
    });
  },

  getUsersRecommendedVenues:async(payload:{lat:Number,lng:Number,city?:String})=>{
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getUsersRecommendedVenues,
      data:payload,
      showCustomError:false,
      showFooterToast:false
      
    });
  },
  checkVenueAvailability:async(payload:{lat?:Number,lng?:Number,city?:String})=>{
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.checkVenueAvailability,
      data:payload,
      showCustomError:false

    });
  },

  /**
   * Location typeahead. `limit` caps at 10 server-side; `lat`/`lng` are optional
   * and only bias the ranking toward the user.
   *
   * Deliberately quiet: this fires on keystrokes, so it must not drive the
   * global loader or raise a toast when a request is superseded.
   */
  searchLocation: async (payload: {
    query: string;
    limit?: number;
    country?: string;
    lat?: number | null;
    lng?: number | null;
  }) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.searchLocation,
      data: payload,
      showLoader: false,
      showCustomError: false,
      showFooterToast: false,
    });
  },

  getTrendingVenues:async(payload:{lat?:Number,lng?:Number,city?:String})=>{
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getTrendingVenues,
      data:payload,
      showCustomError:false,
      showFooterToast:false


    });
  },
  
  getTrendingSports:async()=>{
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getTrendingSports,
      showCustomError:false,
      showSuccessMessage:false
    });
  },

  getVenuePricingRule:async(pathParam:string)=>{
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getVenuePricingRule,
      pathParam,
      showCustomError:false,
      showFooterToast:false
    });
  },

  getMyBookingById: async (bookingId:any) => {
    return await AxiosClient({
      method: ApiMethods.GET,
      url: ApiEndpoints.getMyBookingDetailsById,
      pathParam:bookingId,
      showSuccessMessage:false
    });
  },

  rescheduleBooking:async (data:rescheduleBookingType) => {
    return await AxiosClient({
      method: ApiMethods.POST,
      url: ApiEndpoints.rescheduleBooking,
      data,
      showSuccessMessage:true
    });
  },

  
};


export default ApiBuilder;
